import React from 'react';
import { useTheme, Box, Tooltip, Fab } from '@material-ui/core';
import { useSelector } from 'dva';
import TollIcon from '@material-ui/icons/Toll';
import DataTableNativeML from '@/components/DataTableNativeML';
import ErrorOutlineIcon from '@material-ui/icons/ErrorOutline';
import { fmtThousand } from '@/utils/comUtil';
import { useIntl } from 'umi';
import ArchiveIcon from '@material-ui/icons/Archive';
import SvgIconML from '@/components/SvgIconML/SvgIconML';
import AnalysisResultStyled from './AnalysisResultStyled';

const AnalysisResult = (props) => {
  const {
    setPageData,
    pagination,
    // sortField,
    // setSortField = () => {},
    // setSort,
    handleClickExport,
    downloadRef,
  } = props;
  const intl = useIntl();
  const { formatMessage } = intl;
  const memberCount = useSelector((state) => state.analysis.memberCount);
  const firstPurchaseMember = useSelector(
    (state) => state.analysis.firstPurchaseMember,
  );
  const orderAmountNum = useSelector((state) => state.analysis.orderAmountNum);
  const orderCount = useSelector((state) => state.analysis.orderCount);
  const orderPair = useSelector((state) => state.analysis.orderPair);
  const totalPurchaseMember =
    useSelector((state) => state.analysis.totalPurchaseMember) || 0;
  const vipOrderCount =
    useSelector((state) => state.analysis.vipOrderCount) || 0;
  const vipSeatCount = useSelector((state) => state.analysis.vipSeatCount) || 0;
  const vipSalesPaid = useSelector((state) => state.analysis.vipSalesPaid) || 0;
  const orderSalesList = useSelector((state) => state.analysis.orderSalesList);

  const loadingEffect = useSelector((state) => state.loading);
  const loading = loadingEffect.effects['analysis/getOrderSalesList'];
  const { data, total } = orderSalesList || {};
  // const [saleSort, setSaleSort] = useState(true);
  // const [storeNoSort, setStoreNoSort] = useState(true);
  // const [storeNameSort, setStoreNameSort] = useState(true);
  // eslint-disable-next-line no-unused-vars
  // const [storeTypeSort, setStoreTypeSort] = useState(true);
  // const [registerCountSort, setRegisterCountSort] = useState(true);
  // const [orderCountSort, setOrderCountSort] = useState(true);
  // const [salesQuantitySort, setSalesQuantitySort] = useState(true);
  // const [salesPaidSort, setSalesPaidSort] = useState(true);
  // const [newMemberPercentSort] = useState(true);
  // const [oldMemberPercentSort] = useState(true);
  // const [noMemberPercentSort] = useState(true);
  // const [firstPurchaseMemberSort, setFirstPurchaseMemberSort] = useState(true);
  const theme = useTheme();

  const salesList = [
    {
      icon: 'registeredmember',
      // title: '新增注册会员',
      title: formatMessage({ id: 'cm.analysis.n02.lbl01' }),
      titleEn: 'Registered Member',
      num: memberCount,
    },
    {
      icon: 'firstPurchaseMember',
      // title: '新增有购买会员',
      title: formatMessage({ id: 'cm.analysis.n02.lbl02' }),
      titleEn: 'New Known Consumer',
      num: firstPurchaseMember,
    },
    {
      icon: 'salesNumber',
      // title: '销售笔数',
      title: formatMessage({ id: 'cm.analysis.n02.lbl03' }),
      titleEn: 'Number of Sales',
      num: orderCount,
    },
    {
      icon: 'salesPair',
      // title: '销售双数',
      title: formatMessage({ id: 'cm.analysis.n02.lbl04' }),
      titleEn: 'Sales Pair',
      num: orderPair,
    },
    {
      icon: () => (
        <TollIcon sx={{ width: '24px', height: '24px', color: '#EEEEEE' }} />
      ),
      title: '销售金额',
      titleEn: 'Sales Volume',
      num: orderAmountNum,
      isMoney: true,
    },
    {
      icon: 'firstPurchaseMember',
      title: '总购买会员数',
      // title: formatMessage({ id: 'cm.analysis.n02.lbl02' }),
      titleEn: 'Total number of purchasing members',
      num: totalPurchaseMember,
    },
  ];

  const vipSalesList = [
    {
      icon: 'registeredmember',
      title: 'VIP订单数',
      titleEn: 'Number of VIP orders',
      num: vipOrderCount,
    },
    {
      icon: 'firstPurchaseMember',
      title: 'VIP座位数',
      titleEn: 'Number of VIP seats',
      num: vipSeatCount,
    },
    {
      icon: 'salesNumber',
      title: 'VIP销售额',
      titleEn: 'VIP sales',
      num: vipSalesPaid,
      isMoney: true,
    },
  ];

  // column排序
  // useMemo(() => {
  //   setSort(storeNoSort);
  // }, [storeNoSort]);

  // useMemo(() => {
  //   setSort(saleSort);
  // }, [saleSort]);

  // useMemo(() => {
  //   setSort(storeNameSort);
  // }, [storeNameSort]);

  // useMemo(() => {
  //   setSort(storeTypeSort);
  // }, [storeTypeSort]);

  // useMemo(() => {
  //   setSort(orderCountSort);
  // }, [orderCountSort]);

  // useMemo(() => {
  //   setSort(registerCountSort);
  // }, [registerCountSort]);

  // useMemo(() => {
  //   setSort(salesQuantitySort);
  // }, [salesQuantitySort]);

  // useMemo(() => {
  //   setSort(salesPaidSort);
  // }, [salesPaidSort]);

  // useMemo(() => {
  //   setSort(firstPurchaseMemberSort);
  // }, [firstPurchaseMemberSort]);

  // useMemo(() => {
  //   setSort(newMemberPercentSort);
  // }, [newMemberPercentSort]);

  // useMemo(() => {
  //   setSort(oldMemberPercentSort);
  // }, [oldMemberPercentSort]);

  // useMemo(() => {
  //   setSort(noMemberPercentSort);
  // }, [noMemberPercentSort]);

  const showTooltipTitle = (title, tip) => {
    return (
      <>
        {title}
        <Tooltip title={tip} placement="top" arrow>
          <ErrorOutlineIcon
            sx={{
              width: '10px',
              height: '10px',
              color: '#1565C0',
              marginBottom: '10px',
            }}
          />
        </Tooltip>
      </>
    );
  };

  const columns = [
    {
      // '新增会员注册数量',
      title: showTooltipTitle(
        formatMessage({ id: 'cm.analysis.c01.lbl05' }),
        formatMessage({ id: 'cm.analysis.c01.tip13' }),
        'registerCount',
      ),
      align: 'center',
      id: 'registerCount',
      key: 'registerCount',
      // fieldSort: registerCountSort,
      // setSort: setRegisterCountSort,
      // isSort: true,
    },
    {
      // title: '销售笔数',
      title: formatMessage({ id: 'cm.analysis.c01.lbl06' }),
      align: 'center',
      id: 'orderCount',
      key: 'orderCount',
    },
    {
      // title: '新增有购买会员',
      title: formatMessage({ id: 'cm.analysis.c01.lbl07' }),
      align: 'center',
      id: 'firstPurchaseMember',
      key: 'firstPurchaseMember',
      render: (item) =>
        item.firstPurchaseMember !== null
          ? fmtThousand(item.firstPurchaseMember, 0)
          : '',
    },
    {
      // title: '销售双数',
      title: formatMessage({ id: 'cm.analysis.c01.lbl08' }),
      align: 'center',
      id: 'salesQuantity',
      key: 'salesQuantity',
    },
    {
      // title: '销售金额',
      title: formatMessage({ id: 'cm.analysis.c01.lbl09' }),
      align: 'center',
      id: 'salesPaid',
      key: 'salesPaid',
      render: (item) =>
        item.salesPaid !== null ? fmtThousand(item.salesPaid, 0) : '',
    },
    {
      title: '总购买会员数',
      align: 'center',
      id: 'totalPurchaseMember',
      key: 'totalPurchaseMember',
      render: (item) =>
        item.totalPurchaseMember !== null
          ? fmtThousand(item.totalPurchaseMember, 0)
          : '',
    },
    {
      title: 'VIP订单数',
      align: 'center',
      id: 'vipOrderCount',
      key: 'vipOrderCount',
      render: (item) => item.vipOrderCount,
    },
    {
      title: 'VIP座位数',
      align: 'center',
      id: 'vipSeatCount',
      key: 'vipSeatCount',
      render: (item) => item.vipSeatCount,
    },
    {
      title: 'VIP销售额',
      align: 'center',
      id: 'vipSalesPaid',
      key: 'vipSalesPaid',
      render: (item) =>
        item.vipSalesPaid !== null ? fmtThousand(item.vipSalesPaid, 0) : '',
    },
  ];

  return (
    <AnalysisResultStyled theme={theme}>
      <div className="analysis-wrap">
        <div className="box-wrap-left">
          {salesList &&
            salesList.map((item) => (
              <Box className="analysis-content-left">
                {typeof item.icon === 'function' ? (
                  <>{item.icon()}</>
                ) : (
                  <SvgIconML name={item.icon} size={24}></SvgIconML>
                )}
                <span className="left-title">{item.title}</span>
                <span className="left-title-en">{item.titleEn}</span>
                {item.isMoney ? (
                  <div className="right-title-en-num">
                    ¥
                    <span className="right-title-en">
                      {fmtThousand(item.num, 0)}
                    </span>
                  </div>
                ) : (
                  <span className="right-title-en">
                    {fmtThousand(item.num)}
                  </span>
                )}
              </Box>
            ))}
          {/* <Box className="analysis-content-right">
            <TollIcon
              sx={{ width: '24px', height: '24px', color: '#EEEEEE' }}
            ></TollIcon>
            <span className="left-title">
              {formatMessage({ id: 'cm.analysis.n02.lbl05' })}
            </span>
            <span className="left-title-en">Sales Volume</span>
            <div className="right-title-en-num">
              ¥
              <span className="right-title-en">
                {fmtThousand(orderAmountNum, 0)}
              </span>
            </div>
          </Box> */}
        </div>
      </div>

      <div className="analysis-wrap">
        <div className="box-wrap-left">
          {vipSalesList &&
            vipSalesList.map((item) => (
              <Box className="analysis-content-left">
                {typeof item.icon === 'function' ? (
                  <>{item.icon()}</>
                ) : (
                  <SvgIconML name={item.icon} size={24}></SvgIconML>
                )}
                <span className="left-title">{item.title}</span>
                <span className="left-title-en">{item.titleEn}</span>
                {item.isMoney ? (
                  <div className="right-title-en-num">
                    ¥
                    <span className="right-title-en">
                      {fmtThousand(item.num, 0)}
                    </span>
                  </div>
                ) : (
                  <span className="right-title-en">
                    {fmtThousand(item.num)}
                  </span>
                )}
              </Box>
            ))}
          <Box className="analysis-content-left"></Box>
          <Box className="analysis-content-left"></Box>
          <Box className="analysis-content-right"></Box>
        </div>
      </div>

      <div className="table-wrap">
        <div className="export-wrapper">
          <Fab
            ref={downloadRef}
            data-log={JSON.stringify({
              oid: 'btn_offline_store_customer_analysis_details_download',
              events: ['_ev'],
              params: {
                initUrl: window.location.origin + window.location.pathname,
              },
            })}
            variant="extended"
            size="small"
            color="primary"
            aria-label="add"
            className="export"
            onClick={handleClickExport}
          >
            <ArchiveIcon sx={{ width: '24px', height: '24px' }} />
            {formatMessage({ id: 'coupon.data.n02.btn01' })}
          </Fab>
        </div>
        <div style={{ marginTop: '38px' }}>
          <DataTableNativeML
            total={total}
            loading={loading}
            paging={true}
            columns={columns}
            page={pagination}
            changePage={(pageObj) => {
              setPageData(pageObj);
            }}
            data={data}
            // sortField={sortField}
            // setSortField={setSortField}
            // sortType={'multiline'}
          ></DataTableNativeML>
        </div>
      </div>
    </AnalysisResultStyled>
  );
};

export default AnalysisResult;
